import React, { Component } from 'react';
import lottie from 'lottie-web';
import loader from '../../assets/animations/loader.json';

import editIcon from '../../assets/images/edit-icon.svg';
import infoIcon from '../../assets/images/info-icon.svg';
import { joinClasses, classNameWithMods } from '../../utils/helpers';
import '../Tooltip/Tooltip.scss';

/** @import {SectionProps, SectionState} from './Section1Types' */

/** @extends {Component<SectionProps, SectionState>} */
export default class Section extends Component {
    constructor(/** @type {SectionProps} */ props) {
        super(props);

        this.popupRef = React.createRef();

        this.state = {
            popupOpen: false,
            valid: this.props.valid ? this.props.valid : true,
            modifiers: this.props.modifiers ? this.props.modifiers : [],
            showTooltip: this.props.showTooltip ? this.props.showTooltip : false,
            hideEditing: this.props.hideEditing ? this.props.hideEditing : false,
            closeEditingOnConfirm: this.props.closeEditingOnConfirm ? this.props.closeEditingOnConfirm : true,
            infoTop: 0,
            infoLeft: 0,
            saving: false
        };
    }

    togglePopup = (/** @type {React.MouseEvent<HTMLAnchorElement, MouseEvent>} */ event) =>  {
        event.preventDefault();

        let button = event.currentTarget;
        let rect = button.getBoundingClientRect();
        let prect = button.offsetParent?.getBoundingClientRect();

        this.setState(({ popupOpen }) => ({
            popupOpen: !popupOpen,
            infoTop: rect.top - (prect?.top || 0) + 31,
            infoLeft: rect.left - (prect?.left || 0) - 16
        }));
    };

    startEditing = () => {
        this.props.onStart && this.props.onStart();
        this.props.setEditing && this.props.setEditing(true);
    };

    cancelEditing = () => {
        this.props.onCancel && this.props.onCancel();
        this.props.setEditing && this.props.setEditing(false);
    };

    approveEditing = async () => {
        this.setState({ saving: true });
        let valid = true;
        if (this.props.validation) {
            valid = await this.props.validation();
        }
        if (!valid) {
            this.setState({ saving: false });
            return;
        }
        if (this.state.closeEditingOnConfirm) {
            this.props.setEditing && this.props.setEditing(false);
        }
        if (this.props.onSave) {
            await this.props.onSave();
        }
        this.setState({ saving: false });
    };

    render() {
        let containsHtml = typeof(this.props.tooltipContent) == 'string' && (this.props.tooltipContent || '').indexOf('/>') > 0;

        return (
            <div className={joinClasses(this.props.className, classNameWithMods("my-profile__section", ...this.state.modifiers))}>
                <div className="my-profile__section-title">
                    <div>
                        <span>{this.props.title}</span>
                        {this.state.showTooltip &&
                            <a href="#" id={this.props.toolTipId} onClick={this.togglePopup}>
                                <img alt="info" className="tooltip__img" src={infoIcon} />
                            </a>
                        }
                    </div>

                    {this.state.showTooltip && containsHtml &&
                        <>
                            <div className='tooltip__text'>
                                {this.state.popupOpen && <div ref={this.popupRef}
                                                              className={['tooltip__blended-popup', this.state.popupOpen ? 'is-open' : ''].join(' ')}
                                                              style={{ top: this.state.infoTop, left: this.state.infoLeft }} dangerouslySetInnerHTML={
                                    //@ts-expect-error need to think about typescript
                                    {__html: this.props.tooltipContent}
                                }>
                                </div>}
                            </div>
                        </>
                    }

                    {this.state.showTooltip && !containsHtml &&
                        <>
                            <div className='tooltip__text'>
                                {this.state.popupOpen && <div ref={this.popupRef}
                                                              className={['tooltip__blended-popup', this.state.popupOpen ? 'is-open' : ''].join(' ')}
                                                              style={{ top: this.state.infoTop, left: this.state.infoLeft }}>
                                    {this.props.tooltipContent}
                                </div>}
                            </div>
                        </>
                    }
                </div>
                {this.props.children}
                {!this.state.hideEditing &&
                    <div className="my-profile__button-wrapper">
                        <button className={classNameWithMods('my-profile__edit-button', this.props.editing ? 'hidden' : '')} onClick={this.startEditing}><img src={editIcon} title="Edit" />Edit</button>
                        <div className={classNameWithMods('my-profile__section-right', !this.props.editing ? 'hidden' : '')}>
                            <button className="button button--tertiary button--sml" onClick={this.cancelEditing} disabled={this.state.saving}>Cancel</button>
                            <button className="button button--primary button--sml" onClick={this.approveEditing} disabled={!this.state.valid || this.state.saving} style={{ minWidth: '60px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', height: '32px', overflow: 'hidden' }}>
                                {this.state.saving ? (
                                    'Saving..'
                                ) : (
                                    'Save'
                                )}
                            </button>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

/** @extends {Component} */
class LoaderMini extends Component {
  animationEl = React.createRef();

  constructor(/** @type {object} */ props) {
    super(props);
  }

  componentDidMount() {
    lottie.loadAnimation({
      container: this.animationEl.current,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: loader
    });
  }

  render() {
    return (
      <div className="loader__graphic" ref={this.animationEl} />
    );
  }
}